import { renderSTLoginForm, removeSTLoginForm, openSTLoginModal, closeSTLoginModal } from './app.js';
import './styles/app.css';

window.stLoginHandler = { renderSTLoginForm, removeSTLoginForm, openSTLoginModal, closeSTLoginModal };

export { renderSTLoginForm, removeSTLoginForm, openSTLoginModal, closeSTLoginModal };